angular.module('autoremind.reports.unsubscribe')
    .factory('unsubscribeService', ['$rootScope', '$http', '$timeout', '$window', '$filter', '$enhancedHttp', '$q',
    function ($rootScope, $http, $timeout, $window, $filter, $enhancedHttp, $q) {
        var defaultPeriod = 7;
        var service = {
            loadingIndicator: {
                refCount: 0,
                state: true
            },
            contentTypes: [
                {
                    "group": "relation",
                    "type": "all",
                    "name": "All message types",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "reminder",
                    "name": "Reminder",
                    "application": "autoremind"
                },
                {
                    "group": "relation",
                    "type": "birthday",
                    "name": "Birthday greeting",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "latepayment",
                    "name": "Late Payment",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "missed",
                    "name": "Missed Appointment",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "triggered",
                    "name": "Triggered Message",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "newsletter",
                    "name": "Newsletter",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "recalls",
                    "name": "Recalls",
                    "application": "communication"
                },
                {
                    "group": "commercial",
                    "type": "sale",
                    "name": "Sales Messages",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "seasonal",
                    "name": "Seasonal Greetings",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "shortnotice",
                    "name": "Short Notice",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "survey",
                    "name": "Survey",
                    "application": "communication"
                },
                {
                    "group": "relation",
                    "type": "reviews",
                    "name": "Reviews",
                    "application": "communication"
                }
            ],
            filterModels: {
                contentType: 'all',
                from: new Date().getTime() - (defaultPeriod * 24 * 60 * 60 * 1000),
                to: new Date()
            },
            blackList: [],
            // TODO: Find nicer solution to use the function in unsubscribe.filters
            byDateFilter: function (from, to, itemDate) {
                if (from) {
                    // from = new Date(from);
                    if (from > itemDate) {
                        return false;
                    }
                }
                if (to) {
                    to = new Date(to).getTime() + service.getSecondsToTomorrow();
                    if (to < itemDate) {
                        return false;
                    }
                }
                return true;
            },
            getSecondsToTomorrow: function () {
                var now = new Date();
                var tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
                var diff = tomorrow - now;
                return Math.round(diff);
            },
            loadBlackList: function (isRefresh) {
                if (!isRefresh && service.blackList.length > 0) {
                    return;
                }
                console.log('filterModels', service.filterModels);
                service.loadingIndicator.state = true;
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/messagefilter/destinatorfilter/list/',
                    disableErrorDialog: false,
                    retryBtn: true
                }, service.loadingIndicator)
                    .then(function (data) {
                    $timeout(function () {
                        service.loadMessageFilters(data, isRefresh);
                    });
                }, function (error) {
                    console.log('error', error);
                });
            },
            // Running a test with 58 filters took 6 sec when starting all requests (on ar3), 24 sec when running one at a time, 8 sec running 5 threads, 9 sec with 3 threads
            // Put in seperate function allowing to refresh the list if period filter is changed (before pressing Refresh)
            loadMessageFilters: function (blackList, isRefresh) {
                service.blackList.length = 0;
                var deferred = $q.defer();
                var urlCalls = [];
                blackList.destinatorFilters.forEach(function (item) {
                    if (item.messageState !== "blocked") {
                        return;
                    }
                    for (var i in service.blackList) {
                        if (!isRefresh && service.blackList[i].destinatorFilterId === item.destinatorFilterId) {
                            return;
                        }
                    }
                    // Only load if inside selected period
                    //if ($filter('byDateFilter')(filterModels.from, filterModels.to, item.modifiedInt)) {
                    if (service.byDateFilter(service.filterModels.from, service.filterModels.to, item.modifiedInt)) {
                        item.url = '/servlets/messagefilter/destinators/' + +item.destinatorFilterId + '/' + item.media + '/' + item.destinator + '/';
                        urlCalls.push(item);
                        service.inQueue = 0;
                        var maxQueue = 1;
                        var httpInterval = setInterval(function () {
                            if (service.inQueue === maxQueue) {
                                //console.log('Queue max reached');
                                return;
                            }
                            if (urlCalls.length < 1) {
                                clearInterval(httpInterval);
                                console.log('clear interval');
                                return;
                            }
                            service.inQueue++;
                            var dataForRequest = urlCalls.shift();
                            console.log('Queue', service.inQueue, 'Loading message filter', dataForRequest, service.blackList);
                            $enhancedHttp({
                                method: 'GET',
                                headers: { 'Content-Type': 'application/json' },
                                url: dataForRequest.url,
                                disableErrorDialog: false,
                                retryBtn: true
                            }, service.loadingIndicator)
                                .then(function (destinators) {
                                //console.log('destinators', destinators);
                                $timeout(function () {
                                    if (destinators.destinatorFilters === undefined) {
                                        console.log('No destinatorFilters found for', dataForRequest.url);
                                    }
                                    else {
                                        destinators.destinatorFilters.forEach(function (destinator) {
                                            destinator = angular.extend(destinator, destinator, dataForRequest);
                                            if (destinator.messageState === "blocked") {
                                                service.blackList.push(destinator);
                                            }
                                        });
                                    }
                                    service.inQueue--;
                                    //console.log('Queue', service.inQueue, 'Finished loading', dataForRequest);
                                });
                            });
                        }, 100);
                    }
                });
            }
        };
        return service;
    }]);
//# sourceMappingURL=unsubscribe.services.js.map